import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
            {/* Brand Column */}
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl font-semibold text-background-50 tracking-tight">
                  Mulebuy<span className="text-primary-400">Spreadsheets</span>
                </span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed mb-6 max-w-sm">
                Your trusted guide to the mulebuy spreadsheet system. Master agent-based shopping with our comprehensive tutorials, comparisons, and expert reviews.
              </p>
              {/* Newsletter */}
              <form
                data-readdy-form
                id="newsletter-form"
                action="https://readdy.ai/api/form/d8smvvle8ise6dlc8u90"
                method="POST"
                className="flex flex-col sm:flex-row gap-3"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email for updates"
                  required
                  className="flex-1 px-4 py-3 bg-foreground-900 border border-foreground-700 rounded-md text-sm text-background-50 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                  <i className="ri-send-plane-line"></i>
                </button>
              </form>
              <p id="newsletter-message" className="text-xs text-foreground-400 mt-2 hidden"></p>
            </div>

            {/* Links Column 1 - Guide */}
            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Guides</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/what-is-mulebuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Complete Guide
                  </Link>
                </li>
                <li>
                  <Link to="/how-to-use-mulebuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Beginner Tutorial
                  </Link>
                </li>
                <li>
                  <Link to="/is-mulebuy-spreadsheet-safe" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Safety Guide
                  </Link>
                </li>
                <li>
                  <Link to="/mulebuy-spreadsheet-vs-alternatives" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Platform Comparison
                  </Link>
                </li>
              </ul>
            </div>

            {/* Links Column 2 - Categories */}
            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Top Categories</h4>
              <ul className="space-y-3">
                <li>
                  <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Shoes
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Hoodies / Sweaters
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    T-Shirts
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Jackets
                  </a>
                </li>
              </ul>
            </div>

            {/* Links Column 3 - Legal */}
            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Legal</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    Affiliate Disclosure
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 lg:px-8 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} MulebuySpreadsheets. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center border border-foreground-600 rounded-md text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-global-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center border border-foreground-600 rounded-md text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center border border-foreground-600 rounded-md text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <Link to="/" className="text-xs text-foreground-400 hover:text-background-50 transition-colors ml-2">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}